import { render, staticRenderFns } from "./profileInvoices.vue?vue&type=template&id=c99b22f2&scoped=true"
import script from "./profileInvoices.vue?vue&type=script&lang=js"
export * from "./profileInvoices.vue?vue&type=script&lang=js"
import style0 from "./profileInvoices.vue?vue&type=style&index=0&id=c99b22f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99b22f2",
  null
  
)

export default component.exports